import { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import { isEqual } from 'lodash';
import dayjs from 'dayjs';

import Yup from '../../../utils/yup';
import addNotification from '../../../utils/addNotification';
import { NotificationType } from '../../../config';
import useMenus from '../../../context/MenuContext';
import useUsers from '../../../context/UsersContext';
import { FormButtonPanelUI, FormHeaderUI, FormBase, DeleteDialogUI } from '../../Interface';
import ComplaintCoreReports from './ComplaintCoreReports';
import ComplaintCoreFields from './ComplaintCoreFields';
import complaintCoreService from '../../../service/NewComplaint/complaintCore.service';
import { cleanValues, generateAutocompleteItems, getJokerFieldType } from '../../../utils/helper';
import masterDataService from '../../../service/masterData.service';
import newDocumentTypeService from '../../../service/newDocumentType.service';
import { useLoader } from '../../../provider/LoaderProvider';
import ComplaintCoreTabs from './ComplaintCoreTabs';
import { getDynVals } from '../../../utils/DynHelper';
import { JokerFieldTypes, JokerTypes } from '../../../config/joker';
import jokerService from '../../../service/joker.service';

const ComplaintCorePage = () => {
  const { showLoader, hideLoader } = useLoader();
  const { menus, getMenus, getMenuSubMenuId, getCanEdit, getSubMenuNamesByUrls } = useMenus();
  const { getUser, user } = useUsers();
  const [refetchTable, setRefetchTable] = useState(false);
  const [viewField, setViewField] = useState(true);
  const [editButtonVisible, setEditButtonvisible] = useState(true);
  const [addField, setAddField] = useState(true);
  const [canEdit, setCanEdit] = useState(true);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  const [defaultValues, setDefaultValues] = useState({});
  const [selectedValues, setSelectedValues] = useState({});
  const [operatorsDisabled, setOperatorsDisabled] = useState(false);
  const [initValues, setInitValues] = useState({});
  const [defaultSelectedValues, setDefaultSelectedValues] = useState({});
  const [rowSelectionModel, setRowSelectionModel] = useState([]);

  const [autocompleteOptions, setAutoCompleteOptions] = useState({
    company: [],
    complaintStatus: [],
    complaintType: [],
    complaintReason: [],
    complaintResolutionRequest: [],
    complaintResolution: [],
    complaintActionTaken: [],
    documentType: [],
  });
  const [autocompleteData, setAutoCompleteData] = useState({});
  const [dynProps, setDynProps] = useState([]);
  const [dynLoading, setDynLoading] = useState(true);
  const [submenu, setSubmenu] = useState(null);

  const def = {
    id: null,
    companyId: null,
    reference: '',
    itemCode: null,
    itemName: '',
    quantity: '',
    date: dayjs(),
    complaintStatusId: null,
    supplierId: null,
    complaintTypeId: null,
    operationId: null,
    complaintReasonId: null,
    complaintResolutionRequestId: null,
    lastPurchasePrice: '',
    sumPurchasePrice: '',
    complaintResolutionId: null,
    complaintActionTakenId: null,
    baseId: null,
    baseLine: null,
    baseDocnum: '',
    baseDocType: null,
    description: '',
    complaintEffectId: null,
    hasComplaintReport: false,
    joker_char1: '',
    joker_char2: '',
    joker_char3: '',
    joker_char4: '',
    joker_char5: '',
    joker_date1: null,
    joker_date2: null,
    joker_date3: null,
    joker_date4: null,
    joker_date5: null,
    joker_num1: '',
    joker_num2: '',
    joker_num3: '',
    joker_num4: '',
    joker_num5: '',
    joker_int1: '',
    joker_int2: '',
    joker_int3: '',
    joker_int4: '',
    joker_int5: '',
  };

  const [jokerFields, setJokerFields] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getJokerFields = () => {
    jokerService
      .getFields(JokerTypes.COMPLAINT)
      .then((data) => {
        setJokerFields(data);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const initDefaultValues = () => {
    const promiseArray = [];

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .companyToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .complaintStatusToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .complaintTypeToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .complaintReasonToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .complaintResolutionRequestToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .complaintResolutionToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .complaintActionTakenToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        newDocumentTypeService
          .allDocumentTypes()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .operationToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    promiseArray.push(
      new Promise((resolve, reject) => {
        masterDataService
          .complaintEffectToForm()
          .then((data) => {
            resolve(data);
          })
          .catch((e) => {
            reject(e);
          });
      })
    );

    showLoader();

    Promise.all(promiseArray)
      .then((resp) => {
        const aData = {
          company: resp[0],
          complaintStatus: resp[1],
          complaintType: resp[2],
          complaintReason: resp[3],
          complaintResolutionRequest: resp[4],
          complaintResolution: resp[5],
          complaintActionTaken: resp[6],
          documentType: resp[7],
          operationId: resp[8],
          complaintEffect: resp[9],
        };

        setAutoCompleteData(aData);

        const acOptions = {
          company: generateAutocompleteItems(aData.company, ['code', 'name'], 'id'),
          complaintStatus: generateAutocompleteItems(aData.complaintStatus, 'name', 'id'),
          complaintType: generateAutocompleteItems(aData.complaintType, 'name', 'id'),
          complaintReason: generateAutocompleteItems(aData.complaintReason, 'name', 'id'),
          complaintResolutionRequest: generateAutocompleteItems(aData.complaintResolutionRequest, 'name', 'id'),
          complaintResolution: generateAutocompleteItems(aData.complaintResolution, 'name', 'id'),
          complaintActionTaken: generateAutocompleteItems(aData.complaintActionTaken, 'name', 'id'),
          documentType: generateAutocompleteItems(aData.documentType, 'name', 'documentTypeId'),
          operationId: generateAutocompleteItems(aData.operationId, 'operationName', 'operationId'),
          complaintEffect: generateAutocompleteItems(aData.complaintEffect, 'name', 'id'),
        };
        setAutoCompleteOptions(acOptions);

        const defComplaintStatus = aData.complaintStatus.find((status) => status.isDefault);
        const defComplaintType = aData.complaintType.find((type) => type.isDefault);
        const defComplaintReason = aData.complaintReason.find((reason) => reason.isDefault);
        const defComplaintResolutionRequest = aData.complaintResolutionRequest.find((resReq) => resReq.isDefault);
        const defComplaintResolution = aData.complaintResolution.find((res) => res.isDefault);
        const defComplaintActionTaken = aData.complaintActionTaken.find((action) => action.isDefault);
        const defComplaintEffect = aData.complaintEffect.find((effect) => effect.isDefault);

        setDefaultValues((prev) => ({
          ...prev,
          complaintStatusId: defComplaintStatus ? defComplaintStatus.id : null,
          complaintTypeId: defComplaintType ? defComplaintType.id : null,
          complaintReasonId: defComplaintReason ? defComplaintReason.id : null,
          complaintResolutionRequestId: defComplaintResolutionRequest ? defComplaintResolutionRequest.id : null,
          complaintResolutionId: defComplaintResolution ? defComplaintResolution.id : null,
          complaintActionTakenId: defComplaintActionTaken ? defComplaintActionTaken.id : null,
          complaintEffectId: defComplaintEffect ? defComplaintEffect.id : null,
        }));
      })
      .finally(() => {
        hideLoader();
      });
  };

  useEffect(() => {
    getMenus();
    if (!Object.keys(user).length) getUser();

    setDefaultValues(def);
    setDefaultSelectedValues(def);

    initDefaultValues();

    getJokerFields();
  }, []);

  useEffect(() => {
    const submenuId = getMenuSubMenuId('newComplaint/complaintCore');
    setSubmenu(submenuId);
    setCanEdit(getCanEdit(submenuId));
  }, [menus]);

  useEffect(() => {
    if (Object.keys(selectedValues).length > 0) {
      if (!isEqual(defaultSelectedValues, selectedValues)) {
        valuesToForm();
        setOperatorsDisabled(false);
      } else {
        setOperatorsDisabled(true);
        setInitValues(defaultValues);
      }
    } else {
      setOperatorsDisabled(true);
      setInitValues(defaultValues);
    }
  }, [selectedValues]);

  const validationSchema = Yup.object().shape({
    companyId: Yup.number().nullable().required(),
    reference: Yup.string(),
    itemCode: Yup.string().required(),
    itemName: Yup.string().required(),
    quantity: Yup.number().required().min(0.01),
    date: Yup.date().nullable().required(),
    complaintStatusId: Yup.number().nullable(),
    supplierId: Yup.number().nullable(),
    complaintTypeId: Yup.number().nullable(),
    operationId: Yup.number().nullable(),
    complaintReasonId: Yup.number().nullable(),
    complaintResolutionRequestId: Yup.number().nullable(),
    lastPurchasePrice: Yup.number().min(0),
    sumPurchasePrice: Yup.number().min(0),
    complaintResolutionId: Yup.number().nullable(),
    complaintActionTakenId: Yup.number().nullable(),
    baseDocType: Yup.number().nullable(),
    baseDocnum: Yup.string(),
    baseId: Yup.number().nullable(),
    baseLine: Yup.number().nullable(),
    description: Yup.string(),
    complaintEffectId: Yup.number().nullable(),
    hasComplaintReport: Yup.boolean(),
    ...(jokerFields.length > 0
      ? Object.fromEntries(
          jokerFields.map((field) => {
            const fieldType = getJokerFieldType(field);
            return [
              field.field,
              fieldType === JokerFieldTypes.NUMBER ? Yup.number().nullable() : Yup.string().nullable(),
            ];
          })
        )
      : {}),
  });

  const valuesToForm = () => {
    const {
      id,
      companyId,
      reference,
      itemCode,
      itemName,
      quantity,
      date,
      complaintStatusId,
      supplierId,
      complaintTypeId,
      operationId,
      complaintReasonId,
      complaintResolutionRequestId,
      lastPurchasePrice,
      sumPurchasePrice,
      complaintResolutionId,
      complaintActionTakenId,
      baseDocType,
      baseDocnum,
      baseId,
      baseLine,
      description,
      complaintEffectId,
      hasComplaintReport,
      joker_char1,
      joker_char2,
      joker_char3,
      joker_char4,
      joker_char5,
      joker_date1,
      joker_date2,
      joker_date3,
      joker_date4,
      joker_date5,
      joker_num1,
      joker_num2,
      joker_num3,
      joker_num4,
      joker_num5,
      joker_int1,
      joker_int2,
      joker_int3,
      joker_int4,
      joker_int5,
      dynamicProperties,
    } = selectedValues;

    setInitValues({
      id,
      companyId,
      reference,
      itemCode,
      itemName,
      quantity,
      date: dayjs(date),
      complaintStatusId,
      supplierId,
      complaintTypeId,
      operationId,
      complaintReasonId,
      complaintResolutionRequestId,
      lastPurchasePrice,
      sumPurchasePrice,
      complaintResolutionId,
      complaintActionTakenId,
      baseDocType,
      baseDocnum,
      baseId,
      baseLine,
      description,
      complaintEffectId,
      hasComplaintReport,
      joker_char1: joker_char1 ?? '',
      joker_char2: joker_char2 ?? '',
      joker_char3: joker_char3 ?? '',
      joker_char4: joker_char4 ?? '',
      joker_char5: joker_char5 ?? '',
      joker_date1,
      joker_date2,
      joker_date3,
      joker_date4,
      joker_date5,
      joker_num1: joker_num1 ?? '',
      joker_num2: joker_num2 ?? '',
      joker_num3: joker_num3 ?? '',
      joker_num4: joker_num4 ?? '',
      joker_num5: joker_num5 ?? '',
      joker_int1: joker_int1 ?? '',
      joker_int2: joker_int2 ?? '',
      joker_int3: joker_int3 ?? '',
      joker_int4: joker_int4 ?? '',
      joker_int5: joker_int5 ?? '',
      dynamicFields: getDynVals(dynProps, dynamicProperties),
    });
  };

  const handleSubmit = (values, { resetForm }) => {
    if (!editButtonVisible) {
      updateObject(values);
    } else if (!addField) {
      handleInsertObject(values, resetForm);
    }
  };

  const updateObject = async (values) => {
    const updData = {
      ...cleanValues(values),
    };

    complaintCoreService.updateItem(updData).then((data) => {
      addNotification({
        content: 'Sikeres módosítás!',
        type: NotificationType.SUCCESS,
      });

      setSelectedValues(data);
      setRefetchTable(true);
      setEditButtonvisible(true);
      setViewField(true);
    });
  };

  const handleInsertObject = async (values) => {
    const insertObject = {
      ...cleanValues(values),
    };

    complaintCoreService
      .createItem(insertObject)
      .then((data) => {
        addNotification({
          content: 'Sikeres mentés!',
          type: NotificationType.SUCCESS,
        });

        setSelectedValues(data);
        setRowSelectionModel(data.id);
        setRefetchTable(true);
        setAddField(true);
        setViewField(true);
      })
      .finally(() => {
        //@TODO loader
      });
  };

  const handleRemoveElement = async () => {
    const deleteData = {
      deletedBy: user.userId,
    };
    complaintCoreService.deleteData(deleteData, selectedValues.id).then(() => {
      addNotification({
        content: 'Sikeres törlés!',
        type: NotificationType.WARNING,
      });
      setRefetchTable(true);
      setShowDeleteDialog(false);
      setSelectedValues({});
      setInitValues(def);
    });
  };

  return (
    <>
      <FormBase
        name="ComplaintCore"
        leftPanelContent={
          <>
            <div className="h-full overflow-auto custom-scrollbar">
              <FormHeaderUI
                addClick={() => {
                  setSelectedValues(defaultSelectedValues);
                  setViewField(false);
                  setAddField(false);
                }}
                addDisabled={!viewField || !canEdit}
                modClick={() => {
                  setViewField(false);
                  setEditButtonvisible(false);
                }}
                modDisabled={!viewField || operatorsDisabled || !canEdit}
                deleteClick={() => {
                  setShowDeleteDialog(true);
                }}
                deleteDisabled={!viewField || operatorsDisabled || !canEdit}
                copyClick={() => {
                  setViewField(false);
                  setAddField(false);
                }}
                copyDisabled={!viewField || operatorsDisabled || !canEdit}
              />

              <Formik
                initialValues={initValues}
                validationSchema={validationSchema}
                validateOnChange={false}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({ resetForm }) => (
                  <Form>
                    <ComplaintCoreFields
                      viewField={viewField}
                      autocompleteOptions={autocompleteOptions}
                      autocompleteData={autocompleteData}
                    />

                    <ComplaintCoreTabs
                      dynProperties={{ dynProps, setDynProps }}
                      dynLoadingState={{ dynLoading, setDynLoading }}
                      submenuId={submenu}
                      selectedValues={selectedValues}
                      setDefaultValues={setDefaultValues}
                      viewField={viewField}
                      autocompleteOptions={autocompleteOptions}
                      autocompleteData={autocompleteData}
                      disabled={viewField}
                    />

                    <FormButtonPanelUI
                      onCancelClick={() => {
                        setViewField(true);
                        setEditButtonvisible(true);
                        setAddField(true);

                        resetForm();
                      }}
                      disabled={editButtonVisible && addField}
                    />
                  </Form>
                )}
              </Formik>
            </div>
          </>
        }
        rightPanelContent={
          !dynLoading && !isLoading ? (
            <ComplaintCoreReports
              refetch={{ refetchTable, setRefetchTable }}
              values={{ selectedValues, setSelectedValues }}
              viewField={viewField}
              operatorsDisabled={operatorsDisabled}
              rowSelection={{ rowSelectionModel, setRowSelectionModel }}
              autocompleteOptions={autocompleteOptions}
              autocompleteData={autocompleteData}
              dynProps={dynProps}
              submenuId={submenu}
              jokerFields={jokerFields}
            />
          ) : (
            <></>
          )
        }
      />
      <DeleteDialogUI
        handleRemoveElement={handleRemoveElement}
        show={showDeleteDialog}
        onHide={() => setShowDeleteDialog(false)}
      />
    </>
  );
};

export default ComplaintCorePage;
